export default __webpack_public_path__ + "static/media/V410_RoHS.7c3ed3fb.pdf";